import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button } from './ui/button';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md shadow-md text-gray-900'
          : 'bg-white/20 backdrop-blur-md text-white'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center">
            <img 
              src="/nexti-logo.png" 
              alt="NexTI" 
              className="h-12 w-auto"
              style={{ filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, 0.8))' }}
            />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className="hover:text-[#4A2B7F] transition-colors duration-200 font-medium"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="hover:text-[#4A2B7F] transition-colors duration-200 font-medium"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('diferenciais')}
              className="hover:text-[#4A2B7F] transition-colors duration-200 font-medium"
            >
              Diferenciais
            </button>
            <button
              onClick={() => navigate('/login')}
              className="hover:text-[#4A2B7F] transition-colors duration-200 font-medium"
            >
              Abrir Chamado
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="hover:text-[#4A2B7F] transition-colors duration-200 font-medium"
            >
              Contato
            </button>
            <Button
              onClick={() => navigate('/login')}
              className={`${
                scrolled
                  ? 'bg-[#4A2B7F] text-white hover:bg-[#6B46C1]'
                  : 'bg-white text-[#4A2B7F] hover:bg-gray-100'
              } border-2 border-transparent transition-colors`}
            >
              Portal
            </Button>
          </nav>

          {/* Mobile menu button */}
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="md:hidden p-2"
          >
            {mobileMenuOpen ? (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            ) : (
              <svg className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            )}
          </button>
        </div>

        {/* Mobile Navigation */}
        {mobileMenuOpen && (
          <nav className="md:hidden py-4 space-y-2">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left px-4 py-2 hover:bg-white/10 rounded transition-colors"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('servicos')}
              className="block w-full text-left px-4 py-2 hover:bg-white/10 rounded transition-colors"
            >
              Serviços
            </button>
            <button
              onClick={() => scrollToSection('diferenciais')}
              className="block w-full text-left px-4 py-2 hover:bg-white/10 rounded transition-colors"
            >
              Diferenciais
            </button>
            <button
              onClick={() => navigate('/login')}
              className="block w-full text-left px-4 py-2 hover:bg-white/10 rounded transition-colors"
            >
              Abrir Chamado
            </button>
            <button
              onClick={() => scrollToSection('contato')}
              className="block w-full text-left px-4 py-2 hover:bg-white/10 rounded transition-colors"
            >
              Contato
            </button>
            <Button
              onClick={() => navigate('/login')}
              className="w-full bg-white text-[#4A2B7F] hover:bg-gray-100 mt-4"
            >
              Portal
            </Button>
          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;